import ky from 'ky';
import { useEffect, useState } from 'react';
import Config from '../../config';

interface JsonState<T> {
    path: string;
    data: T | null;
}

/**
 * Fetches a JSON file from static-contents/. `data` is `undefined` while the
 * file for the current path is loading and `null` when it could not be read.
 */
const useJson = <T>(path: string): T | null | undefined => {
    const [state, setState] = useState<JsonState<T> | null>(null);

    useEffect(() => {
        let active = true;
        ky.get(new URL(Config.BASE_URL + path, window.location.href))
            .json<T>()
            .then((data) => {
                if (active) {
                    setState({ path, data });
                }
            })
            .catch(() => {
                if (active) {
                    setState({ path, data: null });
                }
            });
        return () => {
            active = false;
        };
    }, [path]);

    return state === null || state.path !== path ? undefined : state.data;
};

export default useJson;
